import type { JSX } from 'react';

import { Document, Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';

import { TemplateSVG } from './components/TemplateSVG';

// Create styles
const styles = StyleSheet.create({
	page: {
		backgroundColor: 'white',
		border: '28pt',
		borderColor: 'black',
		borderStyle: 'solid',
		fontFamily: 'Noto Sans',
	},
	template: { position: 'absolute' },
	qrcode: {
		position: 'absolute',
		height: 128,
		width: 128,
		top: 438,
		left: 232,
		transform: 'rotate(-4deg)',
		borderRadius: 8,
	},
	content: { display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', maxHeight: 736 },
	title: { alignItems: 'center', display: 'flex', height: 421, justifyContent: 'center', padding: 28, width: 556 },
	scanToSign: {
		fontSize: 13,
		fontWeight: 700,
		position: 'absolute',
		width: 170,
		alignSelf: 'flex-start',
		bottom: 310,
		left: 20,
		textTransform: 'uppercase',
		transform: 'rotate(-16deg)',
		transformOrigin: 'center bottom',
		textAlign: 'center',
	},
});

// get other fonts urls from here: https://developers.google.com/fonts/docs/developer_api
Font.register({
	family: 'Noto Sans',
	fonts: [
		{
			src: 'https://fonts.gstatic.com/s/notosans/v35/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyAaBN9d41P6zHtY.ttf',
			fontWeight: 700,
		},
		{
			src: 'https://fonts.gstatic.com/s/notosans/v35/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyBUBN9d41P6zHtY.ttf',
			fontWeight: 900,
		},
	],
});

// disables hyphens
/* istanbul ignore next */
Font.registerHyphenationCallback((word) => [word]);

type FlyerAPDFProps = { petitionTitleDataURL: string; scanToSign: string; qrCodeDataURL: string };
export function FlyerAPDF({ petitionTitleDataURL, scanToSign, qrCodeDataURL }: FlyerAPDFProps): JSX.Element {
	return (
		<Document>
			<Page size="LETTER" style={styles.page}>
				{/* content with fixed size and placement */}
				<View style={styles.template}>
					<TemplateSVG />
				</View>
				<Image style={styles.qrcode} src={qrCodeDataURL} />
				{/* content with dynamic size */}
				<View style={styles.content}>
					{/* petition title */}
					<Image src={petitionTitleDataURL} style={styles.title} />
					{/* sign-label */}
					<Text style={styles.scanToSign}>{scanToSign}</Text>
				</View>
			</Page>
		</Document>
	);
}
